import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import { showNotification } from "Common/utils/Notification";
import { useParams } from "react-router-dom";
import BreadCrumb from "Common/BreadCrumb";
import { HEADER_UPDATE_ROUTE, HEADER_LIST_ROUTE } from "constants/routeEnum";
import { ToastContainer } from "react-toastify";
import LoaderComponent from "Common/Components/Loader/Loader";
import Drawer from "Common/Components/Drawer";
import DynamicLink from "Common/Components/DynamicLink/DynamicLink";
import Modal from "Common/Components/Modal";
import ImageView from "../../Common/Components/ImageView/ImageView";
import ImageData from "Common/Components/customImage/ImageSegment";
import HeaderLink from "./HeaderLink";
import FooterLink from "./FooterLink";
import { v4 as uuidv4 } from "uuid";

const UpdateHeader = () => {
  const navigate = useNavigate();
  const [dynamicLink, setDynamicLink] = useState<any>("");
  const [firstLevelHeaders, setFirstLevelHeaders] = useState<any>([]);
  const [secondLevelHeaders, setSecondLevelHeaders] = useState<any>([]);
  const [thirdLevelHeaders, setThirdLevelHeaders] = useState<any>([]);
  const [fourthLevelHeaders, setFourthLevelHeaders] = useState<any>([]);
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  const [imageUrl, setImageUrl] = useState<any>();
  const [imageId, setImageId] = useState("");
  const [index, setIndex] = useState<any>(undefined);
  const [subIndex, setSubIndex] = useState<any>(undefined);
  const [data, setData] = useState<any>("");
  const [subFooterIndex, setSubFooterIndex] = useState<any>(undefined);
  const [showLink, setShowLink] = useState<any>(false);
  const toggleLink = () => setShowLink(!showLink);
  const [mobileLogo, setMobileLogo] = useState<any>("");
  const [mobileLogoId, setMobileLogoId] = useState<any>("");
  const [desktopLogo, setDesktopLogo] = useState<any>("");
  const [desktopLogoId, setDesktopLogoId] = useState<any>("");
  const [footerMobileLogo, setFooterMobileLogo] = useState<any>("");
  const [footerMobileLogoId, setFooterMobileLogoId] = useState<any>("");
  const [footerDesktopLogo, setFooterDesktopLogo] = useState<any>("");
  const [footerDesktopLogoId, setFooterDesktopLogoId] = useState<any>("");
  const [logo, setLogo] = useState(undefined);
  const [footerLinks, setFooterLinks] = useState<any>([]);
  // const { id } = useParams();
  const [footerIndex, setFooterIndex] = useState<any>(undefined);
  const [loader, setLoader] = useState<any>(false);

  const [versionCopy, setVersionCopy] = useState<any>({});
  const [originalData, setOriginalData] = useState<any>({});

  const [errors, setErrors] = useState<any>({
    firstLevelHeaders: firstLevelHeaders?.map(() => ({
      label: "",
      url: "",
    })),
  });

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (logo === undefined) {
        setDesktopLogo(imageData?.media_url);
        setDesktopLogoId(imageData?.media_id);
      } else if (logo === "mobile") {
        setMobileLogo(imageData?.media_url);
        setMobileLogoId(imageData?.media_id);
      } else if (logo === "footer_desktop") {
        setFooterDesktopLogo(imageData?.media_url);
        setFooterDesktopLogoId(imageData?.media_id);
      } else if (logo === "footer_mobile") {
        setFooterMobileLogo(imageData?.media_url);
        setFooterMobileLogoId(imageData?.media_id);
      }
    }
  }, [imageData, logo]);

  useEffect(() => {
    if (dynamicLink && dynamicLink !== "") {
      if (index && data === "first_level_headers") {
        updateFirstLevelHeader(index - 1, "url", dynamicLink);
      }
      if (index && data === "second_level_headers") {
        updateSecondLevelHeader(index - 1, "url", dynamicLink);
      }
      if (index && data === "third_level_headers") {
        updateThirdLevelHeader(index - 1, "url", dynamicLink);
      }
      if (index && data === "fourth_level_headers") {
        updateFourthLevelHeader(index - 1, "url", dynamicLink);
      }
      if (footerIndex && data === "urlFooter") {
        updateFooterLink(footerIndex - 1, "url", dynamicLink);
      }
      if (footerIndex && subFooterIndex && data === "urlSubFooter") {
        updateSubFooterLink(
          footerIndex - 1,
          subFooterIndex - 1,
          "value",
          dynamicLink
        );
      }
    }
  }, [dynamicLink, index, subIndex, footerIndex, subFooterIndex, data]);

  useEffect(() => {
    async function fetchContent() {
      try {
        const res = await callApi(`v1/pagedata/header-info`, "post", {});
        if (res && res?.status === "Success") {
          setOriginalData(res.data.pagedata);
          setVersionCopy(res.data.versionCopy);
          if (res.data.versionCopy?.first_level_headers) {
            setFirstLevelHeaders(
              res.data.versionCopy?.first_level_headers || []
            );
          } else {
            setFirstLevelHeaders(res.data.pagedata?.first_level_headers || []);
          }
          if (res.data.versionCopy?.second_level_headers) {
            setSecondLevelHeaders(
              res.data.versionCopy?.second_level_headers || []
            );
          } else {
            setSecondLevelHeaders(
              res.data.pagedata?.second_level_headers || []
            );
          }
          if (res.data.versionCopy?.third_level_headers) {
            setThirdLevelHeaders(
              res.data.versionCopy?.third_level_headers || []
            );
          } else {
            setThirdLevelHeaders(res.data.pagedata?.third_level_headers || []);
          }
          if (res.data.versionCopy?.fourth_level_headers) {
            setFourthLevelHeaders(
              res.data.versionCopy?.fourth_level_headers || []
            );
          } else {
            setFourthLevelHeaders(
              res.data.pagedata?.fourth_level_headers || []
            );
          }
          if (res.data.versionCopy?.footer_links) {
            setFooterLinks(res.data.versionCopy?.footer_links || []);
          } else {
            setFooterLinks(res.data.pagedata?.footer_links || []);
          }
          setDesktopLogo(res.data.pagedata?.desktop_logo_image_url);
          setFooterDesktopLogo(
            res.data.pagedata?.footer_desktop_logo_image_url
          );
          setMobileLogo(res.data.pagedata?.mobile_logo_image_url);
          setFooterMobileLogo(res.data.pagedata?.footer_mobile_logo_image_url);
        }
      } catch (e) {
        showNotification(
          "An error occurred while fetching data. Please try again.",
          "error"
        );
      }
    }

    fetchContent();
  }, []);

  const addFooterLink = () => {
    setFooterLinks([
      ...footerLinks,
      { label: "", url: "", subfooter_links: [] },
    ]);
  };

  // Update footer link
  const updateFooterLink = (index, key, value) => {
    const updatedLinks = [...footerLinks];
    updatedLinks[index][key] = value;
    setFooterLinks(updatedLinks);
  };

  // Remove footer link
  const removeFooterLink = (index) => {
    setFooterLinks(footerLinks.filter((_, i) => i !== index));
  };

  // Add sub-footer link
  const addSubFooterLink = (index) => {
    const updatedLinks = [...footerLinks];
    updatedLinks[index]?.subfooter_links?.push({
      label: "",
      value: "",
      level: "",
    });
    setFooterLinks(updatedLinks);
  };

  // Update sub-footer link
  const updateSubFooterLink = (footerIndex, subIndex, key, value) => {
    const updatedLinks = [...footerLinks];

    if (
      updatedLinks[footerIndex] &&
      Array.isArray(updatedLinks[footerIndex].subfooter_links) &&
      updatedLinks[footerIndex].subfooter_links[subIndex]
    ) {
      updatedLinks[footerIndex].subfooter_links[subIndex][key] = value;
      setFooterLinks(updatedLinks);
    } else {
      showNotification(updatedLinks[footerIndex], "error");
    }
  };

  // Remove sub-footer link
  const removeSubFooterLink = (footerIndex, subIndex) => {
    const updatedLinks = [...footerLinks];
    updatedLinks[footerIndex].subfooter_links = updatedLinks[
      footerIndex
    ].subfooter_links.filter((_, i) => i !== subIndex);
    setFooterLinks(updatedLinks);
  };

  //Header
  const addFirstLevelHeader = () => {
    setFirstLevelHeaders([
      ...firstLevelHeaders,
      { label: "", url: "", code: "" },
    ]);
  };

  const addSecondLevelHeader = () => {
    setSecondLevelHeaders([
      ...secondLevelHeaders,
      { label: "", url: "", group_under: "" },
    ]);
  };

  const addThirdLevelHeader = () => {
    setThirdLevelHeaders([
      ...thirdLevelHeaders,
      { label: "", url: "", group_under: "" },
    ]);
  };

  const addFourthLevelHeader = () => {
    setFourthLevelHeaders([
      ...fourthLevelHeaders,
      { label: "", url: "", group_under: "" },
    ]);
  };

  // Update header link
  const updateFirstLevelHeader = (index, key, value) => {
    const updatedLinks = [...firstLevelHeaders];
    updatedLinks[index][key] = value;
    setFirstLevelHeaders(updatedLinks);
  };

  const updateSecondLevelHeader = (index, key, value) => {
    const updatedLinks = [...secondLevelHeaders];
    updatedLinks[index][key] = value;
    setSecondLevelHeaders(updatedLinks);
  };

  const updateThirdLevelHeader = (index, key, value) => {
    const updatedLinks = [...thirdLevelHeaders];
    updatedLinks[index][key] = value;
    setThirdLevelHeaders(updatedLinks);
  };

  const updateFourthLevelHeader = (index, key, value) => {
    const updatedLinks = [...fourthLevelHeaders];
    updatedLinks[index][key] = value;
    setFourthLevelHeaders(updatedLinks);
  };

  // Remove header link
  const removeFirstLevelHeader = (index) => {
    setFirstLevelHeaders(firstLevelHeaders.filter((_, i) => i !== index));
  };

  const removeSecondLevelHeader = (index) => {
    setSecondLevelHeaders(secondLevelHeaders.filter((_, i) => i !== index));
  };

  const removeThirdLevelHeader = (index) => {
    setThirdLevelHeaders(thirdLevelHeaders.filter((_, i) => i !== index));
  };

  const removeFourthLevelHeader = (index) => {
    setFourthLevelHeaders(fourthLevelHeaders.filter((_, i) => i !== index));
  };

  const handlePublish = async () => {
    try {
      const res = await callApi(`v1/pagedata/publish-header-info`, "post", {});
      if (res?.status === "Success") {
        showNotification("Published successfully");
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };

  const handleSave = async () => {
    // const newErrors = {
    //   buttons: buttons?.map(() => ({ label: "", url: "" })),
    // };

    // buttons?.forEach((button, index) => {
    //   if (!button.label.trim()) {
    //     newErrors.buttons[index].label = "label is required .";
    //   }
    //   if (!button.url.trim()) {
    //     newErrors.buttons[index].url = "url is required .";
    //   }
    // });

    // setErrors(newErrors);

    // if (newErrors?.buttons?.every((error) => !error.label && !error.url)) {
    let first_level_headers = firstLevelHeaders.map((header) => ({
      label: header.label,
      url: header.url,
      code: _.kebabCase(header.label),
    }));
    let second_level_headers = secondLevelHeaders.map((header) => ({
      label: header.label,
      url: header.url,
      code: _.kebabCase(header.label),
      group_under: header.group_under,
    }));
    let third_level_headers = thirdLevelHeaders.map((header) => ({
      label: header.label,
      url: header.url,
      code: _.kebabCase(header.label),
      group_under: header.group_under,
    }));
    let fourth_level_headers = fourthLevelHeaders.map((header) => ({
      label: header.label,
      url: header.url,
      code: _.kebabCase(header.label),
      group_under: header.group_under,
    }));
    const payload = {
      first_level_headers: first_level_headers,
      second_level_headers: second_level_headers,
      third_level_headers: third_level_headers,
      fourth_level_headers: fourth_level_headers,
      footer_links: footerLinks,
      mobile_logo_image_url: mobileLogo,
      mobile_logo_image_id: mobileLogoId,
      desktop_logo_image_url: desktopLogo,
      desktop_logo_image_id: desktopLogoId,
      footer_mobile_logo_image_url: footerMobileLogo,
      footer_mobile_logo_image_id: footerMobileLogoId,
      footer_desktop_logo_image_url: footerDesktopLogo,
      footer_desktop_logo_image_id: footerDesktopLogoId,
    };
    try {
      setLoader(true);
      const res = await callApi(`v1/pagedata/update-header-info`, "post", {
        pagedata: payload,
      });
      setLoader(false);
      if (res && res?.status === "Success") {
        showNotification(" Updated successfully!", "success");

        navigate(HEADER_LIST_ROUTE);
      } else {
        showNotification("Something went wrong. Please try again.", "error");
      }
    } catch (e) {
      showNotification("An error occurred . Please try again.", "error");
    }
    // }
  };

  return (
    <>
      <div className="flex justify-between">
        <BreadCrumb
          title={HEADER_UPDATE_ROUTE}
          pageTitle={HEADER_LIST_ROUTE}
          version="v1"
        />
        <div className="flex justify-end my-4">
          <button
            onClick={() => handlePublish()}
            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Publish
          </button>
        </div>
      </div>
      <ToastContainer />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
            <div className="relative p-4 xl:col-span-3">
              {desktopLogo && (
                <label className="inline-block mb-2 text-base font-medium">
                  Desktop Logo
                </label>
              )}
              <div className="flex justify-start ">
                <div className="flex my-4">
                  {desktopLogo ? (
                    <div className="flex items-center">
                      <ImageData
                        imageLink={desktopLogo}
                        setImageData={setImageData}
                        setImageLink={setDesktopLogo}
                      />
                      <div className="h-3 ml-3">
                        <button
                          onClick={() => {
                            toggleImage();
                            setLogo(undefined);
                            setImageData(undefined);
                          }}
                          className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        >
                          Change
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button
                      onClick={() => {
                        toggleImage();
                        setLogo(undefined);
                        setImageData(undefined);
                      }}
                      className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      Add Desktop Logo
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="pt-4 pr-4 xl:col-span-3 xl:col-start-10">
              {mobileLogo && (
                <label className="inline-block mb-2 text-base font-medium">
                  Mobile Logo
                </label>
              )}
              <div className="flex justify-end">
                <div className="flex my-4">
                  {mobileLogo ? (
                    <div className="flex items-center">
                      <ImageData
                        imageLink={mobileLogo}
                        setImageData={setImageData}
                        setImageLink={setMobileLogo}
                      />
                      <div className="h-3 ml-3">
                        <button
                          onClick={() => {
                            toggleImage();
                            setLogo("mobile");
                            setImageData(undefined);
                          }}
                          className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        >
                          Change
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button
                      onClick={() => {
                        toggleImage();
                        setLogo("mobile");
                        setImageData(undefined);
                      }}
                      className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      Add Mobile Logo
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
            <div className="relative p-4 xl:col-span-3">
              {footerDesktopLogo && (
                <label className="inline-block mb-2 text-base font-medium">
                  Footer Desktop Logo
                </label>
              )}
              <div className="flex justify-start ">
                <div className="flex my-4">
                  {footerDesktopLogo ? (
                    <div className="flex items-center">
                      <ImageData
                        imageLink={footerDesktopLogo}
                        setImageData={setImageData}
                        setImageLink={setFooterDesktopLogo}
                      />
                      <div className="h-3 ml-3">
                        <button
                          onClick={() => {
                            toggleImage();
                            setLogo("footer_desktop");
                            setImageData(undefined);
                          }}
                          className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        >
                          Change
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button
                      onClick={() => {
                        toggleImage();
                        setLogo("footer_desktop");
                        setImageData(undefined);
                      }}
                      className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      Add Footer Desktop Logo
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="pt-4 pr-4 xl:col-span-3 xl:col-start-10">
              {footerMobileLogo && (
                <label className="inline-block mb-2 text-base font-medium">
                  Footer Mobile Logo
                </label>
              )}
              <div className="flex justify-end">
                <div className="flex my-4">
                  {footerMobileLogo ? (
                    <div className="flex items-center">
                      <ImageData
                        imageLink={footerMobileLogo}
                        setImageData={setImageData}
                        setImageLink={setFooterMobileLogo}
                      />
                      <div className="h-3 ml-3">
                        <button
                          onClick={() => {
                            toggleImage();
                            setLogo("footer_mobile");
                            setImageData(undefined);
                          }}
                          className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                        >
                          Change
                        </button>
                      </div>
                    </div>
                  ) : (
                    <button
                      onClick={() => {
                        toggleImage();
                        setLogo("footer_mobile");
                        setImageData(undefined);
                      }}
                      className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      Add Footer Mobile Logo
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <label className="inline-block mr-4 text-base font-medium">
                  First Level
                </label>
              </div>
              <div className="flex items-center">
                <button
                  onClick={addFirstLevelHeader}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  Add First Level Header
                </button>
              </div>
            </div>
            {versionCopy?.first_level_headers?.length > 0 && (
              <div className="grid grid-cols-1 gap-4 mb-4 xl:grid-cols-12">
                {originalData?.first_level_headers?.map((header, index) => (
                  <div key={index} className="py-4 xl:col-span-4">
                    <HeaderLink
                      isEditable={false}
                      label={header.label}
                      url={header.url}
                      levelName={"first_level_headers"}
                      index={index}
                      toggleLink={toggleLink}
                      setIndex={setIndex}
                      setData={setData}
                      setDynamicLink={setDynamicLink}
                      updateLevelHeader={updateFirstLevelHeader}
                      removeLevelHeader={removeFirstLevelHeader}
                    />
                  </div>
                ))}
              </div>
            )}
            <div className="grid grid-cols-1 gap-4 mb-4 xl:grid-cols-12">
              {firstLevelHeaders?.map((header, index) => (
                <div key={index} className="py-4 xl:col-span-4">
                  <HeaderLink
                    label={header.label}
                    url={header.url}
                    group_under={header.group_under}
                    isSecondLevel={false}
                    group_list={[]}
                    index={index}
                    levelName={"first_level_headers"}
                    toggleLink={toggleLink}
                    setIndex={setIndex}
                    setData={setData}
                    setDynamicLink={setDynamicLink}
                    updateLevelHeader={updateFirstLevelHeader}
                    removeLevelHeader={removeFirstLevelHeader}
                  />
                </div>
              ))}
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <label className="inline-block mr-4 text-base font-medium">
                  Second Level
                </label>
              </div>
              <div className="flex items-center">
                <button
                  onClick={addSecondLevelHeader}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  Add Second Level Header
                </button>
              </div>
            </div>
            {versionCopy?.second_level_headers?.length > 0 && (
              <div className="grid grid-cols-1 gap-4 mb-4 xl:grid-cols-12">
                {originalData?.second_level_headers?.map((header, index) => (
                  <div key={index} className="py-4 xl:col-span-4">
                    <HeaderLink
                      isEditable={false}
                      label={header.label}
                      url={header.url}
                      index={index}
                      toggleLink={toggleLink}
                      levelName={"second_level_headers"}
                      setIndex={setIndex}
                      setData={setData}
                      setDynamicLink={setDynamicLink}
                      updateLevelHeader={updateSecondLevelHeader}
                      removeLevelHeader={removeSecondLevelHeader}
                    />
                  </div>
                ))}
              </div>
            )}
            <div className="grid grid-cols-1 gap-4 mb-4 xl:grid-cols-12">
              {secondLevelHeaders?.map((header, index) => (
                <div key={index} className="py-4 xl:col-span-4">
                  <HeaderLink
                    label={header.label}
                    url={header.url}
                    group_under={header.group_under}
                    isSecondLevel={true}
                    group_list={firstLevelHeaders}
                    index={index}
                    levelName={"second_level_headers"}
                    toggleLink={toggleLink}
                    setIndex={setIndex}
                    setData={setData}
                    setDynamicLink={setDynamicLink}
                    updateLevelHeader={updateSecondLevelHeader}
                    removeLevelHeader={removeSecondLevelHeader}
                  />
                </div>
              ))}
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <label className="inline-block mr-4 text-base font-medium">
                  Third Level
                </label>
              </div>
              <div className="flex items-center">
                <button
                  onClick={addThirdLevelHeader}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  Add Third Level Header
                </button>
              </div>
            </div>
            {versionCopy?.third_level_headers?.length > 0 && (
              <div className="grid grid-cols-1 gap-4 mb-4 xl:grid-cols-12">
                {originalData?.third_level_headers?.map((header, index) => (
                  <div key={index} className="py-4 xl:col-span-4">
                    <HeaderLink
                      isEditable={false}
                      label={header.label}
                      url={header.url}
                      index={index}
                      levelName={"third_level_headers"}
                      toggleLink={toggleLink}
                      setIndex={setIndex}
                      setData={setData}
                      setDynamicLink={setDynamicLink}
                      updateLevelHeader={updateThirdLevelHeader}
                      removeLevelHeader={removeThirdLevelHeader}
                    />
                  </div>
                ))}
              </div>
            )}
            <div className="grid grid-cols-1 gap-4 mb-4 xl:grid-cols-12">
              {thirdLevelHeaders?.map((header, index) => (
                <div key={`${index}dd`} className="py-4 xl:col-span-4">
                  <HeaderLink
                    label={header.label}
                    url={header.url}
                    group_under={header.group_under}
                    isSecondLevel={true}
                    group_list={secondLevelHeaders}
                    index={index}
                    levelName={"third_level_headers"}
                    toggleLink={toggleLink}
                    setIndex={setIndex}
                    setData={setData}
                    setDynamicLink={setDynamicLink}
                    updateLevelHeader={updateThirdLevelHeader}
                    removeLevelHeader={removeThirdLevelHeader}
                  />
                </div>
              ))}
            </div>

            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <label className="inline-block mr-4 text-base font-medium">
                  Fourth Level
                </label>
              </div>
              <div className="flex items-center">
                <button
                  onClick={addFourthLevelHeader}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  Add Fourth Level Header
                </button>
              </div>
            </div>
            {versionCopy?.fourth_level_headers?.length > 0 && (
              <div className="grid grid-cols-1 gap-4 mb-4 xl:grid-cols-12">
                {originalData?.fourth_level_headers?.map((header, index) => (
                  <div key={index} className="py-4 xl:col-span-4">
                    <HeaderLink
                      isEditable={false}
                      label={header.label}
                      url={header.url}
                      index={index}
                      levelName={"fourth_level_headers"}
                      toggleLink={toggleLink}
                      setIndex={setIndex}
                      setData={setData}
                      setDynamicLink={setDynamicLink}
                      updateLevelHeader={updateFourthLevelHeader}
                      removeLevelHeader={removeFourthLevelHeader}
                    />
                  </div>
                ))}
              </div>
            )}
            <div className="grid grid-cols-1 gap-4 mb-4 xl:grid-cols-12">
              {fourthLevelHeaders?.map((header, index) => (
                <div key={index} className="py-4 xl:col-span-4">
                  <HeaderLink
                    label={header.label}
                    url={header.url}
                    group_under={header.group_under}
                    isSecondLevel={true}
                    group_list={thirdLevelHeaders}
                    index={index}
                    levelName={"fourth_level_headers"}
                    toggleLink={toggleLink}
                    setIndex={setIndex}
                    setData={setData}
                    setDynamicLink={setDynamicLink}
                    updateLevelHeader={updateFourthLevelHeader}
                    removeLevelHeader={removeFourthLevelHeader}
                  />
                </div>
              ))}
            </div>
            <div className="flex justify-end my-4">
              <button
                onClick={addFooterLink}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add Footer Link
              </button>
            </div>
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              {footerLinks?.map((footer, index) => (
                <div key={`${index}dd`} className="py-4 xl:col-span-4">
                  <FooterLink
                    footer={footer}
                    updateFooterLink={updateFooterLink}
                    index={index}
                    toggleLink={toggleLink}
                    setIndex={setIndex}
                    setFooterIndex={setFooterIndex}
                    setSubFooterIndex={setSubFooterIndex}
                    setSubIndex={setSubIndex}
                    addSubFooterLink={addSubFooterLink}
                    removeSubFooterLink={removeSubFooterLink}
                    updateSubFooterLink={updateSubFooterLink}
                    removeFooterLink={removeFooterLink}
                    setData={setData}
                    setDynamicLink={setDynamicLink}
                    removeLevelHeader={removeFooterLink}
                  />
                </div>
              ))}
            </div>

            {/* Save Button */}
            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={() => handleSave()}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {loader ? <LoaderComponent /> : "Save"}
              </button>

              {/* <Link
                className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                to={HEADER_LIST_ROUTE}
              >
                cancel
              </Link> */}
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showLink}
        onHide={toggleLink}
        id="defaultModal"
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600 flex flex-col h-full"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b border-slate-200 dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-500 hover:text-red-500 dark:text-zink-200 dark:hover:text-red-500"
        >
          <Modal.Title className="text-16">{"Text"}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          {/* <h5 className="mb-3 text-16">{}</h5> */}
          <p className="h-[400px] text-slate-500 dark:text-zink-200">
            <DynamicLink
              showLink={showLink}
              toggleLink={toggleLink}
              setLink={setDynamicLink}
            />
          </p>
        </Modal.Body>
      </Modal>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default UpdateHeader;
